// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__Epdc8","signatureButtonsRight":"ModalSign_signatureButtonsRight__2_7KA"};